module.exports = __webpack_public_path__ + "static/img/case13.031ea52.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case/case13.jpg
// module id = 2mC6
// module chunks = 0